import {IModalView} from "../../../views/IModalView";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {Component} from "@angular/core";
import {AbstractHeaderModalView} from "../../../views/AbstractHeaderModalView";

@Component({
  selector: 'link-modal-header',
  templateUrl: './modal-header.view.html',
  styleUrls: ['./modal-header.view.scss']
})
export class ModalHeaderView extends AbstractHeaderModalView {

  constructor(dialogService: DialogService,
              dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);
  }

  onCloseIconClicked() {
    this.close();
  }
}
